import { render, staticRenderFns } from "./Fan2.vue?vue&type=template&id=d3fb9ae4&scoped=true"
import script from "./Fan2.vue?vue&type=script&lang=js"
export * from "./Fan2.vue?vue&type=script&lang=js"
import style0 from "./Fan2.vue?vue&type=style&index=0&id=d3fb9ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3fb9ae4",
  null
  
)

export default component.exports